<template>
  <section class="mx-auto my-3 max-w-7xl px-4 md:my-0 md:py-12">
    <slot />
  </section>
</template>
